export default __webpack_public_path__ + "static/media/wave_hello_3.83c5c770.gif";